import { Integration, SystemAlertSchema } from "../types";
import { BackendTelemetryClient } from "./BackendTelemetryClient";
import { TelemetryClient } from "./TelemetryClient";

export const clients = {
    "system-coralogix": function (i): BackendTelemetryClient {
        return new BackendTelemetryClient(i);
    },
    "system-datadog": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-sentry": function (i): BackendTelemetryClient {
        return new BackendTelemetryClient(i);
    },
    "system-pagerduty": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-opsgenie": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-prometheus-alertmanager": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-grafana": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-splunk": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-cloudwatch": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-azure-monitor": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-gcp-monitoring": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    },
    "system-newrelic": function (): TelemetryClient {
        throw new Error("Function not implemented.");
    }
} satisfies Record<SystemAlertSchema, (integration: Integration) => TelemetryClient>;